import React ,{Component} from "react";
import {Loading} from "./partials/Global/Loading";
import {Contact} from "./partials/ContactUs/Contact";
import {CopyRight} from "./partials/Global/CopyRight";
import {Location} from "./partials/ContactUs/Location";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";


class ContactUs extends Component {
    render() {
        return (
            <div>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <Contact/>
                    <Location/>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </div>
        );
    }
}

export default ContactUs;
